<template>
    <div v-if="loading" class="loading">Loading...</div>
    <div :class="blur ? 'blur-lg' : '' " class="fixed h-screen w-screen bg-[url('../assets/background/forest.jpg')] bg-cover bg-center bg-no-repeat">
        <div class="flex h-full">

            <div class="h-full w-1/6">
                <div class="flex flex-col relative p-5 gap-10">
                    <router-link :to="`/checkpoint`">
                        <div class="bg-white rounded-lg shadow-lg shadow-slate-500 w-fit p-2">
                            <img class="w-10" src="../assets/icon/icon-home.png" alt="home">
                        </div>
                    </router-link>
                    <div class="xl:mt-48 lg:mt-48 md:mt-10 sm:mt-10">
                        <img class="w-[600px] absolute" src="../assets/avatar/avatar-flip.png" alt="avatar">
                    </div>
                </div>
            </div>

            <div class="h-full flex flex-col w-4/6 justify-center items-center gap-y-4">
                <div class="w-full flex justify-center items-center bg-transparent shadow-xl gap-x-2 border rounded-lg py-4">
                    <p class="xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl">เเยกขยะทิ้งตามสี</p>
                    <Sound :checkpoint='3' :autoplay='false'/>
                </div>

                <div class="h-auto w-auto flex gap-x-6 border rounded-lg shadow-lg bg-orange-100">                              
                    <img class="xl:w-72 lg:w-60 md:w-44 sm:w-44" :src="levels[$store.state.level].data[current_round].url">
                </div> 

                <div class="flex justify-around gap-x-4">
                    <div class="bg-rose-100 border-red-400 border-4 hover:border-red-600 hover:ring-4 shadow-lg rounded-lg" @click="checkAnswer('trash-rad', $store.state.level)">
                        <img class="scale-150" src="../assets/trash/trash-rad.png" alt="trash-rad">
                    </div>
                    <div class="bg-yellow-100 border-yellow-400 border-4 hover:border-yellow-600 hover:ring-4 shadow-lg rounded-lg" @click="checkAnswer('trash-yellow', $store.state.level)">
                        <img class="scale-150" src="../assets/trash/trash-yellow.png" alt="trash-yellow">
                    </div>
                    <div class="bg-lime-100 border-lime-400 border-4 hover:border-lime-600 hover:ring-4 shadow-lg rounded-lg" @click="checkAnswer('trash-green', $store.state.level)">
                        <img class="scale-150" src="../assets/trash/trash-green.png" alt="trash-green">
                    </div>
                    <div class="bg-blue-100 border-blue-400 border-4 hover:border-blue-600 hover:ring-4 shadow-lg rounded-lg" @click="checkAnswer('trash-blue', $store.state.level)">
                        <img class="scale-150" src="../assets/trash/trash-blue.png" alt="trash-blue">
                    </div>
                </div>

            </div>

            <div class="h-full flex flex-col w-1/6 justify-start items-center">
                <p class="my-4 p-8 xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl font-bold border-4 rounded-full bg-orange-300 text-white">{{ current_round + 1 }}/{{ levels[$store.state.level].round }}</p>
            </div>

        </div>
        <Answer :checkCorrect="checkCorrect" :star="star" :resetGame="resetGame" :nextCheckPoint="nextCheckPoint" />         
    </div>
    <HowTo :setShowContent="setShowContent" :checkpoint='3'/>
</template>

<script>
import HowTo from "../components/HowTo.vue";
import Sound from "../components/Sound.vue";
import Answer from "../components/Answer.vue";
import actionUpdateCheckpoint from '../js/firebase-action';
import logPlay from '../js/logs-play';
import soundAnswer from "../js/sound-answer";

const path = '../assets/checkpoint/3';

export default {
    name: "CheckPointTrash",    
    components: {
        HowTo,
        Sound,
        Answer
    },
    data(){
        return {
            blur: true,    
            checkCorrect: '',
            answer: [],
            current_round: 0,
            star: 0,      
            countGameOver: 0,
            path: path+'/plastic.png',
            levels: {
                easy: {
                    round: 1,                    
                    data: [
                        {
                            url: `${path}/plastic.png`,
                            name: 'plastic',     
                            answer: 'trash-blue'                                                   
                        }
                    ]
                },
                medium: {
                    round: 2,                    
                    data: [
                        {
                            url: `${path}/plastic.png`,
                            name: 'plastic', 
                            answer: 'trash-blue'                           
                        },
                        {
                            url: `${path}/paper.png`,
                            name: 'paper',
                            answer: 'trash-yellow'
                        }
                    ]
                },
                hard: {
                    round: 3,                    
                    data: [
                        {
                            url: `${path}/plastic.png`,
                            name: 'plastic',
                            answer: 'trash-blue'
                        },
                        {
                            url: `${path}/paper.png`,
                            name: 'paper',
                            answer: 'trash-yellow'
                        },
                        {
                            url: `${path}/mask.png`,
                            name: 'mask',
                            answer: 'trash-rad'
                        }
                    ]
                }
            }
        };        
    },
    created () {
        !this.$store.state.user_id ? window.location.replace("/#/logout/") : '';          
    },
    methods: {
        setShowContent() {
            this.blur = false;           
        },
        setShowModalCorrect() {
            // this.blur = true;
            this.checkCorrect = 'correct';
        },
        setShowModalInCorrect() {
            // this.blur = true;
            this.checkCorrect = 'incorrect';
        },
        checkGameOver() {            
            console.log('Count Game Over'+ (this.countGameOver + 1));
            this.countGameOver += 1;
            if(this.countGameOver >= 3){                
                this.star = 1;
                this.countGameOver = 0;
                this.updateCheckpointStarInFirebase();
                this.setShowModalInCorrect();                
            }else{
                this.resetGame();
            }            
        },
        checkAnswer(answer, level) {
            const getRoundByLevel = this.levels[level].round;
            const answer_correct = this.levels[level]['data'][this.current_round].answer;
            this.current_round += 1;
            
            console.log({
                level: level,
                answer: answer,
                answer_correct: answer_correct
            });
            
            if(answer !== answer_correct){
                this.current_round = 0;                    
                this.checkGameOver();
                soundAnswer('incorrect');
            }else{                
                if(getRoundByLevel === this.current_round){          
                    this.star = this.countGameOver === 2 ? 2 : 3;
                    this.resetGame();      
                    this.setShowModalCorrect();
                    soundAnswer('correct');
                    this.updateCheckpointStarInFirebase()
                    this.countGameOver = 0; 
                }
            }
        },        
        resetGame(){
            this.current_round = 0;
            this.blur = false;
            this.checkCorrect = '';
        },
        nextCheckPoint(){            
            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level];
            const my_checkpoint = 3;
            const checkpoint_index = [1, 2, 3, 4, 5, 6];

            const next = checkpoint_index.filter((i) => {
                const star = starByCheckpoint[`checkpoint_${i}`];
                return i > my_checkpoint && star < 3 ? i : '';                
            });

            window.location.replace(`/#/checkpoint/${next.length > 0 ? next[0]: ''}`);
        },
        async updateCheckpointStarInFirebase() {
            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            const document_id = this.$store.state.user_id;
            const checkpointUpdate = {
                checkpoint_3: this.star
            }

            const user = this.$store.state.user;
            await logPlay(user, 3, this.star);

            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level]['checkpoint_3'];         

            if(this.star > starByCheckpoint){
                parseCheckpoint[level]['checkpoint_3'] = this.star;
                await actionUpdateCheckpoint(document_id, level, checkpoints, checkpointUpdate);
                this.$store.dispatch('setCheckPoint', parseCheckpoint);
            }
        }
    }
};
</script>